<div class="d-flex justify-content-center keyboard-row px-0">
  <button #buttonVar class="mobile-keyboard-button" (click)="assignCharacter('q', $event)">
    {{ "q" }}
  </button>
  @for (character of firstKeyboardRow(); track character; let lastCharacter = $last) {
  <button class="mobile-keyboard-button" [class.mr-0]="lastCharacter" (click)="assignCharacter(character, $event)">
    {{ character }}
  </button>
  }
</div>

@for (keyboardRow of keyboardRows(); track keyboardRow; let lastRow = $last) {
<div class="d-flex justify-content-center keyboard-row px-0 mt-1">
  @for (character of keyboardRow; track character; let lastCharacter = $last) {
  <button class="mobile-keyboard-button" [class.mr-0]="lastCharacter"
    [ngStyle]="lastRow ? { 'max-width.px': buttonVar.offsetWidth } : {}" (click)="assignCharacter(character, $event)">
    {{ character }}
  </button>
  @if (lastRow && lastCharacter) {
  <button [ngStyle]="{ 'max-width.px': buttonVar.offsetWidth * 2 }"
    class="mobile-keyboard-button remove-button mr-0 ml-2" (click)="removeLastCharacter($event)">
    <i class="fas fa-backspace" style="pointer-events: none"></i>
  </button>
  }
  }
</div>
}

<div class="d-flex justify-content-center keyboard-row px-0 mt-1">
  <div class="col-4" style="line-height: 1.15 !important"></div>
  <div class="col-4 px-0">
    <button class="mobile-keyboard-button" style="width: 33%; background-color: #50b4ae"
      (click)="goToPreviousInput($event)">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          d="M4.38797 8.38038C4.17927 8.17168 4.17927 7.82832 4.38797 7.61962L10.8511 1.15653C11.0598 0.947824 11.4031 0.947824 11.6118 1.15653C11.8205 1.36523 11.8205 1.70858 11.6118 1.91729L5.52911 8L11.6118 14.0827C11.8205 14.2914 11.8205 14.6348 11.6118 14.8435C11.4031 15.0522 11.0598 15.0522 10.8511 14.8435L4.38797 8.38038Z"
          fill="white" />
      </svg>
    </button>
    <button class="mobile-keyboard-button" style="width: 33%; background-color: #50b4ae"
      (click)="goToNextInput($event)">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          d="M11.6118 7.61962C11.8205 7.82832 11.8205 8.17168 11.6118 8.38038L5.14873 14.8435C4.94003 15.0522 4.59668 15.0522 4.38797 14.8435C4.17927 14.6348 4.17927 14.2914 4.38797 14.0827L10.4707 8L4.38797 1.91729C4.17927 1.70858 4.17927 1.36523 4.38797 1.15653C4.59668 0.947824 4.94003 0.947824 5.14873 1.15653L11.6118 7.61962Z"
          fill="white" />
      </svg>
    </button>
  </div>
  <div class="col-4"></div>
</div>